import { render, staticRenderFns } from "./GamePaused.vue?vue&type=template&id=7aac0d41&scoped=true&"
import script from "./GamePaused.vue?vue&type=script&lang=js&"
export * from "./GamePaused.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7aac0d41",
  null
  
)

export default component.exports